import angular from "angular";
import Swal from "sweetalert2";

angular
	.module('app')
	.component('individualImportStudentsModal', {
		template: require('./individual-import-students-modal.html'),
        controller: ['$http', 'Notifier', '$uibModal', 'moment', '$timeout', 'Upload', 'RequestsQueue', 'ErrorResponseParser', '$q', controller],
        bindings: {
            resolve: '<',
            dismiss: '&',
            close: '&'
        }
    });
            
function controller($http, Notifier, $uibModal, moment, $timeout, Upload, RequestsQueue, ErrorResponseParser, $q) {

    let $ctrl = this;

    $ctrl.step = 1;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
    };

    $ctrl.parseExcel = function () {
        $ctrl.parseLoading = true;

        Upload
            .upload({
                url: '/admin/import-users/parse-excel',
                data: {file: $ctrl.file},
            })
            .then(
                function (response) {

                    $ctrl.parseLoading = false;

                    $ctrl.step = 2;

                    $ctrl.search = null;
                    $ctrl.status = null;

                    $ctrl.users = response.data;

                    $ctrl.total = $ctrl.users.length;
                    $ctrl.errorsCount = 0;

                    $ctrl.users.forEach(function (user, ind) {
                        user.display = true;
                        user.ind = ind;
                        user.errors = checkErrorFields(user);

                        if (user.phone) {
                            if (user.is_valid_phone) {
                                if (user.exists_user_id) {
                                    user.status = 'exists';
                                    user.errors = [];
                                } else {
                                    if (user.errors.length) {
                                        user.status = 'error';
                                        $ctrl.errorsCount++;
                                    } else {
                                        user.status = 'new';
                                    }
                                }
                            } else {
                                $ctrl.errorsCount++;
                                user.status = 'error';
                                user.errors.push('Неверный номер телефона: ' + user.phone);
                            }
                        } else {
                            $ctrl.errorsCount++;
                            user.status = 'error';
                            user.errors.push('Нет номера телефона');
                        }

                        checkForDuplicate(user, ind);
                    });

                    setDuplicatesCount();

                },
                function (error) {
                    $ctrl.parseLoading = false;
                    ErrorResponseParser.parse(error);
                }
            );

    };

    function checkForDuplicate(user, ind) {
        if (user.phone !== '') {

            if (user.status === 'error') {
                user.isDuplicate = false;
                return;
            }

            for (let i = 0; i < $ctrl.users.length; i++) {
                if (i !== ind) {
                    let prevUser = $ctrl.users[i];

                    if (user.phone === prevUser.phone && prevUser.status !== 'error') {
                        user.isDuplicate = true;
                        prevUser.isDuplicate = true;
                        return;
                    }
                }
            }

            user.isDuplicate = false;
        }
    }

    function setDuplicatesCount() {
        $ctrl.duplicates = 0;

        $ctrl.users.forEach(user => {
            if (user.isDuplicate) {
                $ctrl.duplicates++;
            }
        });
    }

    function checkErrorFields(user) {

        let res = [];

        if (!user.first_name) {
            res.push('Нет имени');
        }

        if (!user.last_name) {
            res.push('Нет фамилии');
        }

        return res;
    }

    $ctrl.updateFilter = function () {

        let search = $ctrl.search ? $ctrl.search.toLowerCase() : null;

        $ctrl.users.forEach(function (user) {

            let f1 = true, f2 = true;

            if (search) {
                let str = user.last_name + ' ' + user.first_name + ' ' + user.patronymic;
                str = str.toLowerCase();
                if (str.indexOf(search) === -1) {
                    f1 = false;
                }
            }

            if ($ctrl.status === 'duplicated') {
                f2 = user.isDuplicate;
            }

            if ($ctrl.status === 'error') {
                f2 = user.status === 'error';
            }

            user.display = f1 && f2;

        });
    };

    $ctrl.openForm = function (user, ind) {
        $uibModal
            .open({
                component: 'importUserForm',
                resolve: {
                    user: function () {
                        return user;
                    }
                }
            })
            .result
            .then(
                function (result) {

                    user.first_name = result.first_name;
                    user.last_name = result.last_name;
                    user.patronymic = result.patronymic;
                    user.phone = result.phone;
                    user.exists_user_id = result.exists_user_id;
                    user.is_valid_phone = true;
                    user.errors = checkErrorFields(user);

                    if (user.status === 'error') {
                        $ctrl.errorsCount--;
                    }

                    if (user.exists_user_id) {
                        user.status = 'exists';
                        user.errors = [];
                    } else {
                        if (user.errors.length) {
                            user.status = 'error';
                            $ctrl.errorsCount++;
                        } else {
                            user.status = 'new';
                            user.added = false;
                        }
                    }

                    $ctrl.users.forEach(function (us, ind) {
                        checkForDuplicate(us, ind);
                    });

                    $timeout(setDuplicatesCount());

                }
            );
    };

    $ctrl.delItem = function (user, ind) {

        if (!confirm('Вы действительно хотите удалить данного пользователя со списка?')) {
            return;
        }

        if (user.status === 'error') {
            $ctrl.errorsCount--;
        }

        $ctrl.total--;
        $ctrl.users.splice(ind, 1);

        $ctrl.users.forEach(function (us, ind) {
            checkForDuplicate(us, ind);
        });

        setDuplicatesCount();
    };


    $ctrl.openThirdStep = function () {

        $ctrl.sendInvite = false;
        $ctrl.password = null;

        let pass = true;

        $ctrl.users.forEach(function (user) {
            if ($ctrl.duplicates || $ctrl.errorsCount) {
                pass = false;
            }
        });

        if (pass === false) {
            Swal.fire({
                icon: 'error',
                title: 'Запрещено!',
                text: 'Исправьте ошибки в списке!'
            })
        } else {
            $ctrl.step = 3;
        }
    };

    $ctrl.backToSecondStep = function () {
        $ctrl.step = 2;
    };

    $ctrl.attachStudents = function () {

        if (!$ctrl.password) {
            alert('Введите пароль');
            return;
        }

        if ($ctrl.requestLoading) {
            return;
        }

        let users = $ctrl.users.filter(v => v.attachStatus !== 'attached');

        if (!users.length) {
            return;
        }

        $ctrl.requestLoading = true;

        $ctrl.registerErrors = [];
        $ctrl.attachErrors = [];

        $ctrl.requestsQueue = RequestsQueue();

        $ctrl.requestsQueue.setFinishCallback(function () {
            $ctrl.requestLoading = false;
        });

        users.forEach(function (user) {
            if (!user.exists_user_id) {
                create(user);
            } else {
                attach(user);
            }
        });

        function create(user) {
            $ctrl
                .requestsQueue
                .add({
                    method: 'POST',
                    url: '/admin/users',
                    data: {
                        name: user.first_name,
                        last_name: user.last_name,
                        patronymic: user.patronymic,
                        phone: user.phone,
                        send_invite: $ctrl.sendInvite,
                        password: $ctrl.password
                    }
                })
                .then(
                    function (response) {
                        user.exists_user_id = response.data.id;
                        attach(user);
                    },
                    function (error) {
                        user.attachStatus = 'registerError';
                        $ctrl.registerErrors.push({
                            user,
                            message: error.status === 422 ? 'Ошибка при заполнении' : error.data.message,
                            additionalData: error.data.errors
                        });
                    }
                );
        }

        function attach(user) {
            $ctrl
                .requestsQueue
                .add({
                    method: 'POST',
                    url: `/admin/courses/${$ctrl.course.id}/individual-training/attach-student`,
                    data: {
                        user_id: user.exists_user_id,
                    }
                })
                .then(
                    function (response) {
                        user.attachStatus = 'attached';
                    },
                    function (error) {
                        user.attachStatus = 'attachError';
                        $ctrl.attachErrors.push({
                            user,
                            message: error.data.message,
                            additionalData: error.data.errors
                        });
                    }
                );
        }

    };

    $ctrl.dismissModal = function () {
        if ($ctrl.step === 1) {
            $ctrl.dismiss();
        } else {
            if (confirm('Вы действительно хотите закрыть окно?')) {
                if ($ctrl.requestLoading) {
                    $ctrl.requestLoading.clear();
                }
                $ctrl.close();
            }
        }
    };
}